import { webClient } from "@shared/apis"
import { StockCounsel } from "@shared/components/StockCounselList"
import { Pagination } from "@shared/types"

export default {
  get: (scheduleId: string | undefined | number, page = 1, size = 1000) =>
    webClient.get<Pagination<StockCounsel>>(`/stock_counsels`, {
      params: { scheduleId, page, size },
    }),
  findBy: (id: string | undefined | number) =>
    webClient.get<StockCounsel>(`/stock_counsels/${id}`),

  post: (
    scheduleId: string | undefined | number,
    shortCode: string,
    stockName: string,
    username: string,
  ) =>
    webClient.post(`/stock_counsels`, {
      scheduleId,
      shortCode,
      stockName,
      username,
    }),
  recodingStart: (stockCounselId: number) =>
    webClient.post(`/stock_counsels/${stockCounselId}/recording/start`),
  recodingEnd: (stockCounselId: number) =>
    webClient.put(`/stock_counsels/${stockCounselId}/recording/end`),
}
